import React from 'react'
import { AuthProvider } from './contexts/AuthContext'
import { BrowserRouter } from 'react-router-dom';
import Router from './components/core/Router';


function App() {

  return (
    <AuthProvider>
        <BrowserRouter>  
            <Router />
        </BrowserRouter>  
    </AuthProvider>
  );
}

export default App;